import React from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'

import UserShield from '../../../../Components/UserShield'

import * as Util from '../../../../Util/util'

import TileButton from '../TileButton'
import ModelViewer from '../../ModelViewer/ModelViewer'

const MODE = {
  DEFAULT: 1,
  DEMOLISH: 2,
  INFO: 3,
}

class UpgradePanel extends React.Component {
  constructor() {
    super()

    this.state = {
      mode: MODE.DEFAULT,
      growOutClass: '',
    }
  }

  //BUILDING ACTIONS
  callUpgradeBuilding(building) {
    const { upgradeBuilding, selectedTile } = this.props
    this.closePopup()
    upgradeBuilding(building, selectedTile)
  }

  callDemolishBuilding(building) {
    const { destroyBuilding, selectedTile } = this.props
    this.closePopup()
    destroyBuilding(building, selectedTile)
  }

  callCreateBattle(battleParameters) {
    const { visitorMap, createBattle } = this.props
    if (!visitorMap.visitorId || !battleParameters) {
      return null
    }
    this.closePopup()
    createBattle({ rivalId: visitorMap.visitorId, battleParameters: battleParameters })
  }

  callRemoveDebris(building) {
    this.closePopup()
    this.callDemolishBuilding(building)
  }

  callMineDebate() {
    const { addScreen } = this.props
    this.closePopup()
    addScreen('mining_screen')
  }

  callDefendChallenge(battle) {
    const { addScreen, removeScreen, setIndividualBattle } = this.props

    if (battle) {
      this.closePopup()
      setIndividualBattle(battle)
      removeScreen('start_battle_screen')
      addScreen('start_battle_screen')
    }
  }

  closePopup() {
    const { removePopup } = this.props

    this.setState({ growOutClass: 'bounceOut-animation' })
    setTimeout(() => {
      removePopup('tile_popup')
    }, 1000)
  }

  //CHECK IF BUILDING CAN BE ATTACKED
  canAttack(building) {
    const { userMap, visitorMap, visitorInfo, attacking } = this.props

    return Util.canAttack(building, userMap, visitorMap, visitorInfo, attacking)
  }

  //RENDER TILE BUTTON

  displayButton(label, icon, action, disabled = false) {
    return (
      <TileButton
        key={label + '_' + icon}
        label={label}
        icon={icon}
        action={action}
        disabled={disabled}
      />
    )
  }

  //RENDERS
  renderTabs() {
    const { mode } = this.state
    const { isTutorialMode } = this.props

    return (
      <div className="panel--tabs">
        <div
          onClick={() => this.setState({ mode: MODE.DEFAULT })}
          className={'panel--tabs__item' + (mode == MODE.DEFAULT ? ' active' : '')}
        >
          <FormattedMessage id="map.buildings.upgrade" />
        </div>
        {!isTutorialMode && (
          <div
            onClick={() => this.setState({ mode: MODE.DEMOLISH })}
            className={'panel--tabs__item' + (mode == MODE.DEMOLISH ? ' active' : '')}
          >
            <FormattedMessage id="map.buildings.remove" />
          </div>
        )}
      </div>
    )
  }

  renderPanelInfo() {
    const { building, buildings } = this.props
    const { mode } = this.state

    let demolishMode = mode == MODE.DEMOLISH
    let b_config = buildings[building.id || building.name]
    if (!b_config) {
      return null
    }
    let level = building.level || 1
    let maxLevel = b_config.maxLevel
    let limitedIndex = building.level > maxLevel ? maxLevel : building.level
    let isDebris = building.type == 'debris'
    let turns = level > 1 || isDebris || demolishMode ? 2 : 1
    let destroyingPrizes = [1, 5, 25, 250]
    let displayingPrize = demolishMode
      ? destroyingPrizes[building.level - 1]
      : b_config.pricePerLevel[limitedIndex]
    let prize = building.type == 'debris' ? 20 : displayingPrize

    // Si estamos a nivel 3 aplicar nivel 4 es instantáneo, ya que es sólo una mejora estética
    if (level === 3 && !demolishMode) turns = 0
    const isPremiumUpgrade = (isDebris || building.level === 3) && !demolishMode
    return (
      <div className="list--panel__info">
        <div className="column">
          <div className="text">
            <FormattedMessage id="map.buildings.cost" />
          </div>
          <div className={`value ${isPremiumUpgrade ? 'blue' : 'violet'}`}>
            {prize}
            <span className={`${isPremiumUpgrade ? 'icon-antimateria' : 'icon-coin'}`} />
          </div>
        </div>
        <div className="column">
          <div className="text">
            <FormattedMessage
              id={`map.buildings.${
                demolishMode || isDebris
                  ? 'destruction'
                  : building.built
                  ? 'evolution'
                  : 'construction'
              }`}
            />
          </div>
          <div className="value">
            {turns === 0 ? (
              <FormattedMessage id="map.buildings.instant" />
            ) : (
              <FormattedMessage id="map.buildings.turn" values={{ turns: turns }} />
            )}
          </div>
        </div>
      </div>
    )
  }

  renderChallenge() {
    const { battles, building, playersList, visitorMap, userInfo } = this.props

    const filtered_battle =
      battles &&
      battles.find((battle) => {
        return (
          battle.building.q == building.q &&
          battle.building.r == building.r &&
          battle.createdBy != userInfo.licenseId &&
          !battle.winnerId
        )
      })
    const playerAttacking = filtered_battle && playersList[filtered_battle.createdBy]
    const playerResults =
      filtered_battle && filtered_battle.results && filtered_battle.results[userInfo.licenseId]

    if (!playerAttacking) {
      return null
    }

    return (
      <React.Fragment>
        <div className="panel--challenge">
          <div className="panel--challenge__shield">
            <UserShield shield={playerAttacking.colonyShield} />
          </div>
          <ul className="panel--challenge__text">
            <li>{playerAttacking.colonyName}</li>
            <li>
              <FormattedMessage id={`map.buildings.city_level.${playerAttacking.cityLevel}`} />
            </li>
            <li>{playerAttacking.name}</li>
          </ul>
        </div>
        {!visitorMap.mapId &&
          !playerResults &&
          this.displayButton('phase.defend', 'icon-desafio', () =>
            this.callDefendChallenge(filtered_battle)
          )}
      </React.Fragment>
    )
  }

  renderBuildingState(building) {
    let currentLabel = null
    let currentIcon = 'bulldozer'

    if (building.built) {
      if (building.evolving) {
        currentLabel = 'evolving'
        currentIcon = 'upgrade'
      }
      if (building.destroying) {
        currentLabel = 'destroying'
        currentIcon = 'ball'
      }

      // if (building.level && b_config &&  building.level == b_config.maxLevel){
      //   currentLabel = 'max'
      //   currentIcon = 'upgrade'
      // }
    } else {
      currentLabel = 'building'
      currentIcon = 'crane'
    }

    return building.blocked ? (
      this.renderChallenge()
    ) : (
      <div className="orange">
        <span className={`icon-${currentIcon}`}> </span>
        <span>
          <FormattedMessage id={`map.buildings.${currentLabel}`} />
        </span>
      </div>
    )
  }

  renderInformationTab() {
    return (
      <div>
        <span className="icon-information"> </span>
        <FormattedMessage id="map.buildings.info" />
      </div>
    )
  }

  renderPrimaryData() {
    const { parameters, building, buildings, visitorMap } = this.props
    const { mode } = this.state

    if (mode == MODE.INFO) {
      return this.renderInformationTab()
    } else {
      let customViewerStyle = {
        width: '50%',
      }
      let demolishMode = mode == MODE.DEMOLISH
      let b_config = buildings[building.id || building.name]
      if (!b_config) {
        return null
      }
      let building_modifications = parameters[building.id || building.name]
        ? parameters[building.id || building.name].modifications
        : null
      let nextLevelBuilding = Util.getNextLevelBuilding(building, b_config)
      let level = building.level || 1
      let maxLevel = b_config.maxLevel
      let default_asset = b_config.assets[level - 1]
      let checkBuildingState =
        building.built && !building.evolving && !building.destroying && !building.blocked

      let canUpgrade = level < maxLevel
      let isNotVisiting =
        !Util.isBlackListed(building.name) && checkBuildingState && !visitorMap.mapId

      // { checkBuildingState ?
      //   (<div className='btn' onClick={ () => this.setState({ mode : MODE.INFO }) }>
      //     <div className='btn--primary'>
      //       <span className='icon-information'>  </span>
      //     </div>
      //   </div> )
      //   :
      //   null }

      return (
        <div className="panel--tabs__container">
          <ModelViewer
            model={default_asset}
            customParams={building_modifications}
            style={customViewerStyle}
          />
          <div className="panel--context__info">
            <div
              className={
                'panel--content' + (canUpgrade && !demolishMode && isNotVisiting ? '' : ' noborder')
              }
            >
              <div className="panel--content__text">
                <div className="text">
                  <FormattedMessage id="map.buildings.level" /> <b>{level}</b>
                </div>
                <div className="text">
                  <FormattedMessage id="map.buildings.production" />
                  <b>{building.production}</b>
                </div>
              </div>
            </div>
            {canUpgrade && !demolishMode && isNotVisiting ? (
              <div className="panel--content">
                <div className="panel--content__text">
                  <div className="text">
                    <FormattedMessage id="map.buildings.level" />
                    <b className="orange">{nextLevelBuilding.level}</b>
                  </div>
                  <div className="text">
                    <FormattedMessage id="map.buildings.production" />
                    <b className="orange">{nextLevelBuilding.production}</b>
                  </div>
                </div>
                <span className="icon-upgrade orange font--large"> </span>
              </div>
            ) : null}
          </div>
        </div>
      )
    }
  }

  renderBuildingTransition(building) {
    const { userData } = this.props
    let currentLabel = null
    let maxCounter = building.level > 1 ? 2 : 1
    let currentValue = 1
    let disable_counter = false

    if (building.built) {
      if (building.evolving != false) {
        currentLabel = 'evolution'
        currentValue = building.evolving - userData.turn
      } else if (building.destroying != false) {
        currentLabel = 'destruction'
        currentValue = building.destroying - userData.turn
        maxCounter = 2
      } else if (building.blocked == true) {
        currentLabel = 'attacked'
      }
    } else {
      currentLabel = 'construction'
    }

    if (building.type == 'debris') {
      maxCounter = 2
    }
    let nextState =
      currentValue == 1 ? 'map.buildings.next_state_one_Turn' : 'map.buildings.next_state'
    return building.blocked ? (
      <div className="red">
        <span>
          <FormattedMessage id="map.buildings.challenge" />
        </span>
      </div>
    ) : (
      <div className="list--panel__info">
        <div className="column single">
          <div className="text">
            <FormattedMessage id={`map.buildings.${currentLabel}`} />
          </div>
          <div className="value">
            {disable_counter ? null : (
              <FormattedMessage
                id={nextState}
                values={{ currentValue: Math.abs(currentValue), maxValue: maxCounter }}
              />
            )}
          </div>
        </div>
      </div>
    )
  }

  render() {
    const {
      building,
      buildings,
      visitorMap,
      attacking,
      currentPhase,
      cursorPos,
      userData: { antimatter, coins },
    } = this.props
    const { mode, growOutClass } = this.state

    let demolishMode = mode == MODE.DEMOLISH
    let infoMode = mode == MODE.INFO
    let b_config = buildings[building.id || building.name]
    if (!b_config) {
      return null
    }
    let battleParameters = null
    let checkBuildingState =
      building.built && !building.evolving && !building.destroying && !building.blocked
    let level = building.level || 1
    let maxLevel = b_config.maxLevel
    let battlePrizeIndex = building.level > 3 ? 2 : building.level - 1
    let battleBuildingPrize = b_config.pricePerLevel
      .filter((val, ind) => ind <= battlePrizeIndex)
      .reduce((last, current) => last + current)
    if (visitorMap.visitorId) {
      battleParameters = {
        q: building.q,
        r: building.r,
        level: building.level,
        name: building.name,
        type: building.type,
        prize: battleBuildingPrize,
      }
    }
    let canUpgrade = level < maxLevel
    let isNotVisiting =
      !Util.isBlackListed(building.name) && checkBuildingState && !visitorMap.mapId
    let icon = Util.getBuildingIcon(building)
    icon = icon == b_config.type ? b_config.icon : 'icon-' + icon
    let isCosmetic = false

    // ¿Can upgrade?
    let upgradeDisabled = false
    let price =
      level < b_config.maxLevel
        ? b_config.pricePerLevel[level]
        : b_config.pricePerLevel[b_config.maxLevel - 1]
    if (level < 3 && coins < price) {
      upgradeDisabled = true
    } else if (level == 4 && antimatter < price) {
      upgradeDisabled = true
    }

    let canDemolish = false
    let destroyingPrizes = [1, 5, 25, 250]

    if (demolishMode && coins < destroyingPrizes[level - 1]) {
      canDemolish = true
    }

    if (level == 3) {
      isCosmetic = true
    }

    //BUTTONS
    let upgradeButton = this.displayButton(
      isCosmetic ? 'map.buildings.cosmetic' : 'map.buildings.upgrade',
      'icon-upgrade',
      () => this.callUpgradeBuilding(building),
      upgradeDisabled
    )
    let demolishButton = this.displayButton(
      'map.buildings.remove',
      'icon-ball',
      () => this.callDemolishBuilding(building),
      canDemolish
    )
    let debateButton = this.displayButton(
      'map.buildings.mine.dispute',
      'icon-debate',
      () => this.callMineDebate(),
      false
    )
    let attackButton = this.displayButton(
      'map.buildings.steal',
      'icon-desafio',
      () => this.callCreateBattle(battleParameters),
      false
    )
    let removeDebris = this.displayButton(
      'map.buildings.debris.remove',
      'icon-bulldozer',
      () => this.callRemoveDebris(building),
      false
    )

    let currentButton = null

    if (demolishMode && isNotVisiting && currentPhase == 3) {
      currentButton = demolishButton
    } else if (!demolishMode && isNotVisiting && canUpgrade && currentPhase == 3) {
      currentButton = upgradeButton
    } else if (visitorMap.mapId && this.canAttack(building) && attacking) {
      currentButton = attackButton
    }

    if (building.type == 'mine' && !visitorMap.mapId && currentPhase == 3) {
      currentButton = debateButton
    }

    if (building.type == 'debris' && !visitorMap.mapId && currentPhase == 3) {
      currentButton = removeDebris
    }
    let mousePadding = 35
    let offset = 350 + mousePadding
    let left = cursorPos
      ? cursorPos.x + offset < window.innerWidth
        ? cursorPos.x + mousePadding
        : cursorPos.x / 2
      : 0
    let top =
      cursorPos &&
      (cursorPos.y + offset > window.innerHeight ? cursorPos.y - cursorPos.y / 2 : cursorPos.y)

    return (
      <div
        className={`panels ${growOutClass} ${!growOutClass ? 'growIn-animation' : ''}`}
        style={cursorPos ? { position: 'absolute', top: top, left: left } : {}}
      >
        <div className="panels--box contextual">
          <div className="panels--box">
            <div className="panels--body">
              <div className="panel--context">
                <div className="panel--context__header">
                  {infoMode ? (
                    <span
                      className="icon-back"
                      onClick={() => this.setState({ mode: MODE.DEFAULT })}
                    ></span>
                  ) : null}
                  <span className={icon}></span>
                  <FormattedMessage id={`buildings.${b_config.id}`} />
                  <span className="icon-cross" onClick={() => this.closePopup()}>
                    {' '}
                  </span>
                </div>
                {isNotVisiting && !infoMode && level < 4 ? this.renderTabs() : null}
                {this.renderPrimaryData()}
                {checkBuildingState &&
                !visitorMap.mapId &&
                (canUpgrade || building.type == 'debris' || (level == 4 && demolishMode))
                  ? this.renderPanelInfo()
                  : null}
                {checkBuildingState ? (
                  currentButton
                ) : (
                  <React.Fragment>
                    {this.renderBuildingTransition(building)}
                    {this.renderBuildingState(building)}
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

UpgradePanel.propTypes = {
  currentPhase: PropTypes.number,
  removeScreen: PropTypes.func,
  removePopup: PropTypes.func,
  setIndividualBattle: PropTypes.func,
  visitorMap: PropTypes.object,
  userInfo: PropTypes.object,
  visitorInfo: PropTypes.object,
  userData: PropTypes.object,
  building: PropTypes.object,
  cursorPos: PropTypes.object,
  playersList: PropTypes.object,
  isTutorialMode: PropTypes.bool,
  userMap: PropTypes.object,
  battles: PropTypes.array,
  attacking: PropTypes.any,
  buildings: PropTypes.object,
  parameters: PropTypes.object,
  selectedTile: PropTypes.object,
  createBattle: PropTypes.func,
  upgradeBuilding: PropTypes.func,
  destroyBuilding: PropTypes.func,
  addScreen: PropTypes.func,
}

export default UpgradePanel
